import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Agencies_BranchesProperties } from '../Models/AgencyMasterProperties';
import { BookingListProperties, BookingRights, BookingStatus, BookingTripDetailsSearch, BookingSearchListProperties, loginUserList, BookingListGetSearchProperties } from '../Models/BookingListProperties';
import { BookingListService } from '../Services/bookingList.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { Countries } from '../Models/Countries';
import { SupplierData, SuppliersListProperties } from '../Models/SuppliersProperties';
import { SuppliersService } from '../Services/suppliers.service';
import { AirportService } from '../Services/airport.service';
import * as $ from 'jquery';
import { AirportProperties } from '../Models/AirportProperties';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { OfflineToOnlineProperties } from '../Models/TicketIssuanceProperties';
import {  TravelInsuranceBookedPassengers } from '../Models/TravelInsuranceProperties';

@Component({
  selector: 'app-back-office-insurance-report',
  templateUrl: './back-office-insurance-report.component.html',
  styleUrls: ['./back-office-insurance-report.component.css']
})
export class BackOfficeInsuranceReportComponent {
  obj = new SuppliersListProperties();
  spdata: SupplierData[] = [];
  bookingsearchobj = new BookingSearchListProperties();
  bookingsearchobjforcall = new BookingSearchListProperties();
  bookingsearchobjnewforTSuse = new BookingSearchListProperties();
  reportData: TravelInsuranceBookedPassengers[] = [];
  collapsed = false;
  constructor( private supplierservice: SuppliersService, private bookingListService: BookingListService, private http: HttpClient, private router: Router, private TripModal: NgbModal) {

  }

  ngOnInit() {
    this.getSupplierList();
  }
  getSupplierList() {
    this.supplierservice.getSuppliersList().subscribe((data: SuppliersListProperties) => {
      if (data) {
        this.obj = data;
        this.spdata = this.obj.otherSupplier
      }
      //console.log(data);
    })
  }


  SearchData() {

    this.bookingsearchobj.agencyId = localStorage.getItem("AgencyId");
    this.bookingsearchobj.userId = Number(localStorage.getItem("UserId"));
    this.bookingsearchobjnewforTSuse = JSON.parse(JSON.stringify(this.bookingsearchobj));
    this.bookingsearchobjforcall = JSON.parse(JSON.stringify(this.bookingsearchobj));
    this.bookingsearchobjforcall.rowCount = 0;
    //if (this.bookingsearchobjforcall.byAgency != "" && this.bookingsearchobjforcall.loginUserId != undefined) {
    //  this.bookingsearchobjforcall.byagencyUser = this.bookingsearchobjforcall.byAgency;
    //  this.bookingsearchobjforcall.byAgency = "";
    //  this.bookingsearchobjnewforTSuse.byagencyUser = this.bookingsearchobjnewforTSuse.byAgency;
    //  this.bookingsearchobjnewforTSuse.byAgency = "";
    //}

    //if (this.bookingsearchobjforcall.loginUserId == null || this.bookingsearchobjforcall.loginUserId == undefined) {
    //  this.bookingsearchobjforcall.loginUserId = 0;
    //}
    if (this.bookingsearchobjforcall.fromBookingDate == null || this.bookingsearchobjforcall.fromBookingDate == undefined) {
      this.bookingsearchobjforcall.fromBookingDate = "";
    }
    if (this.bookingsearchobjforcall.toBookingDate == null || this.bookingsearchobjforcall.toBookingDate == undefined) {
      this.bookingsearchobjforcall.toBookingDate = "";
    }
    //if (this.bookingsearchobjforcall.supplier == null || this.bookingsearchobjforcall.supplier == undefined) {
    //  this.bookingsearchobjforcall.supplier = "";
    //}
    //if (this.bookingsearchobjforcall.pnr == null || this.bookingsearchobjforcall.pnr == undefined) {
    //  this.bookingsearchobjforcall.pnr = "";
    //}
    //if (this.bookingsearchobjforcall.travelDate == null || this.bookingsearchobjforcall.travelDate == undefined) {
    //  this.bookingsearchobjforcall.travelDate = "";
    //}
    //if (this.bookingsearchobjforcall.tkt == null || this.bookingsearchobjforcall.tkt == undefined) {
    //  this.bookingsearchobjforcall.tkt = "";
    //}
    //if (this.bookingsearchobjforcall.trip == null || this.bookingsearchobjforcall.trip == undefined) {
    //  this.bookingsearchobjforcall.trip = "";
    //}
    //if (this.bookingsearchobjforcall.name == null || this.bookingsearchobjforcall.name == undefined) {
    //  this.bookingsearchobjforcall.name = "";
    //}
    //if (this.bookingsearchobjforcall.byAgency == null || this.bookingsearchobjforcall.byAgency == undefined || this.bookingsearchobjforcall.byAgency == "") {
    //  this.bookingsearchobjforcall.byAgency = "";

    //}
   
    this.bookingListService.GetB2BBackOfficeInsuranceConfirmedlistBySearchCriteria(this.bookingsearchobjforcall).subscribe((data) => {
      this.reportData = data;
      /*this.bookingsearchobj = new BookingSearchListProperties();*/
      document.querySelector(".LoadButton").classList.remove("activeLoading");
    })
  }
  //nextSearchData() {

  //  this.bookingsearchobjnewforTSuse.rowCount = this.reportData.length;
  //  if (this.bookingsearchobjnewforTSuse.bookingID == null || this.bookingsearchobjnewforTSuse.bookingID == undefined) {
  //    this.bookingsearchobjnewforTSuse.bookingID = 0;
  //  }
  //  if (this.bookingsearchobjnewforTSuse.loginUserId == null || this.bookingsearchobjnewforTSuse.loginUserId == undefined) {
  //    this.bookingsearchobjnewforTSuse.loginUserId = 0;
  //  }
  //  if (this.bookingsearchobjnewforTSuse.fromBookingDate == null || this.bookingsearchobjnewforTSuse.fromBookingDate == undefined) {
  //    this.bookingsearchobjnewforTSuse.fromBookingDate = "";
  //  }
  //  if (this.bookingsearchobjnewforTSuse.toBookingDate == null || this.bookingsearchobjnewforTSuse.toBookingDate == undefined) {
  //    this.bookingsearchobjnewforTSuse.toBookingDate = "";
  //  }
  //  if (this.bookingsearchobjnewforTSuse.supplier == null || this.bookingsearchobjnewforTSuse.supplier == undefined) {
  //    this.bookingsearchobjnewforTSuse.supplier = "";
  //  }
  //  if (this.bookingsearchobjnewforTSuse.pnr == null || this.bookingsearchobjnewforTSuse.pnr == undefined) {
  //    this.bookingsearchobjnewforTSuse.pnr = "";
  //  }
  //  if (this.bookingsearchobjnewforTSuse.travelDate == null || this.bookingsearchobjnewforTSuse.travelDate == undefined) {
  //    this.bookingsearchobjnewforTSuse.travelDate = "";
  //  }
  //  if (this.bookingsearchobjnewforTSuse.tkt == null || this.bookingsearchobjnewforTSuse.tkt == undefined) {
  //    this.bookingsearchobjnewforTSuse.tkt = "";
  //  }
  //  if (this.bookingsearchobjnewforTSuse.trip == null || this.bookingsearchobjnewforTSuse.trip == undefined) {
  //    this.bookingsearchobjnewforTSuse.trip = "";
  //  }
  //  if (this.bookingsearchobjnewforTSuse.name == null || this.bookingsearchobjnewforTSuse.name == undefined) {
  //    this.bookingsearchobjnewforTSuse.name = "";
  //  }
  //  if (this.bookingsearchobjnewforTSuse.byAgency == null || this.bookingsearchobjnewforTSuse.byAgency == undefined || this.bookingsearchobjnewforTSuse.byAgency == "") {
  //    this.bookingsearchobjnewforTSuse.byAgency = "";

  //  }
  //  if (this.bookingsearchobjnewforTSuse.byagencyUser == null || this.bookingsearchobjnewforTSuse.byagencyUser == undefined) {
  //    this.bookingsearchobjnewforTSuse.byagencyUser = "";
  //    this.bookingsearchobjnewforTSuse.loginUserId = 0;
  //  }
  //  if (this.bookingsearchobjnewforTSuse.bookingStatus == null || this.bookingsearchobjnewforTSuse.bookingStatus == undefined) {
  //    this.bookingsearchobjnewforTSuse.bookingStatus = 0;
  //  }
  //  this.bookingListService.GetB2BBackOfficebookinglistBySearchCriteria(this.bookingsearchobjnewforTSuse).subscribe((data) => {
  //    document.querySelector(".NextButton").classList.remove("activeLoadings");
  //    if (data.length > 0) {


  //      let listnew: BookingListGetSearchProperties[] = [];
  //      listnew = data;
  //      /*  this.bookingList = [...listnew]*/
  //      /*      this.bookingList= this.bookingList.map(s => { return { ...s, data } });*/
  //      for (let i = 0; i < listnew.length; i++) {
  //        let objs = new BookingListGetSearchProperties();
  //        objs.agencyId = listnew[i].agencyId;
  //        objs.bookingDate = listnew[i].bookingDate;
  //        objs.bookingID = listnew[i].bookingID;
  //        objs.bookingStatus = listnew[i].bookingStatus;
  //        objs.name = listnew[i].name;
  //        objs.pnr = listnew[i].pnr;
  //        objs.requestTypeName = listnew[i].requestTypeName;
  //        objs.supplier = listnew[i].supplier;
  //        objs.tkt = listnew[i].tkt;
  //        objs.travelDate = listnew[i].travelDate;
  //        objs.trip = listnew[i].trip;
  //        objs.amount = listnew[i].amount;
  //        objs.loginName = listnew[i].loginName;
  //        this.reportData.push(objs);
  //      }
  //      //console.log(this.bookingList);
  //    }
  //    else {
  //      document.getElementById("Message_next").innerHTML = "No More Data";
  //      document.getElementById("errortext").classList.remove("hidemarginss");
  //      setTimeout(function () {


  //        document.getElementById("Message_next").innerHTML = "";
  //        document.getElementById("errortext").classList.add("hidemarginss");

  //      }

  //        , 5000);
  //    }
  //  })

  //}
  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "#f9f9f9", "color": "#212529", "font-weight": "bold" });
    $(".dx-checkbox-icon").css({ "border": "1px solid black" });
    $(".dx-button-content").css({ "background-color": "var(--first-color-second)" });
    $(".dx-icon.dx-icon-export-to").css({ "color": "white" });
    $(".dx-datagrid-header-panel").css({ "background-color": "#f9f9f9" });
    $(".dx-toolbar-items-container").css({ "background-color": "#f9f9f9" });
    $(".dx-row.dx-data-row.dx-row-lines.dx-column-lines").css({ "border": "none", "background-color": "#f9f9f9" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };
  onExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      autoFilterEnabled: true,
      customizeCell: function (options) {
        const excelCell = options;
        // exce = { name: 'Arial', size: 12 };
        // excelCell.alignment = { horizontal: 'left' };
      }
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'B2BBackOfficeReport.xlsx');
        });
    });
    e.cancel = true;
  }
  infoText(currentPageNumber, totalPageCount, totalRowCount) {
    let pagenum = currentPageNumber;

    //let number = this.dataGrid.instance.pageCount();
    if (pagenum == totalPageCount) {
      //console.log('totalPageCount', totalPageCount);
      //console.log('pagenum', pagenum);
      if (totalRowCount > 1) {
        document.getElementById('buttonnext').classList.remove('hiddenclass');
      }
    }
    else {
      try {
        document.getElementById('buttonnext').classList.add('hiddenclass');
      }
      catch (ex) { console.log(ex); }

    }

  }
  NextButtonClick() {
    document.querySelector(".NextButton").classList.add("activeLoadings");
    //this.nextSearchData();
  }
  LoadButtonClick() {
    document.querySelector(".LoadButton").classList.add("activeLoading");
    this.SearchData();
  }

}
